export const featureCards = [
  {
    title: "Find Viral Clips",
    subtitle: "Find moments most likely to perform.",
  },
  {
    title: "Cam Combiner",
    subtitle: "Multi-camera podcast editing and AI direction.",
  },
  {
    title: "Viral Clip Studio",
    subtitle: "Short-form clip creation with captions and B-roll.",
  },
  {
    title: "Smart Promo",
    subtitle: "AI-generated hooks, titles, descriptions, and promotional content.",
  },
  {
    title: "Publish Everywhere",
    subtitle: "Upload once and distribute across multiple platforms.",
  },
];

export const workflowSteps = [
  {
    title: "Upload",
    text: "Drop long-form content and source metadata once.",
  },
  {
    title: "Edit & Enhance",
    text: "Trim, caption, and polish with AI suggestions.",
  },
  {
    title: "Publish",
    text: "Push to platforms from one workspace.",
  },
  {
    title: "Track Results",
    text: "See views, retention, and engagement by channel.",
  },
  {
    title: "Learn & Improve",
    text: "A/B prompts and hooks on top-performing clips.",
  },
];

export const proofChecklist = [
  {
    label: "Clips identified",
    text: "Every upload is scored and split into hook-ready segments.",
  },
  {
    label: "Caption quality",
    text: "Captions are generated per clip format and platform readability checks.",
  },
  {
    label: "Promotion copy",
    text: "Hooks and metadata are optimized for each connected destination.",
  },
];

export const exampleContent = [
  {
    tag: "Long-form to clip",
    text: "From 45 min interview to 12 high-retention clips in minutes.",
  },
  {
    tag: "AI promotion copy",
    text: "Hook + description generated and adapted per platform format.",
  },
  {
    tag: "Platform output",
    text: "Same source clip, optimized with 3 platform-ready variants.",
  },
];

export const pricingCards = [
  {
    name: "Starter",
    subtitle: "Try the core workflow",
    price: "$0",
    note: "Forever",
    cta: "Start Free",
    bullets: [
      "15 monthly credits",
      "3 uploads per month",
      "1 connected platform",
      "Basic analytics",
    ],
  },
  {
    name: "Creator",
    subtitle: "For consistent publishing",
    price: "$14.99",
    note: "per month",
    cta: "Choose Creator",
    bullets: [
      "150 monthly credits",
      "20 uploads per month",
      "5 connected platforms",
      "Email support",
    ],
    featured: true,
  },
  {
    name: "Studio",
    subtitle: "For higher-volume creators",
    price: "$34.99",
    note: "per month",
    cta: "Choose Studio",
    bullets: [
      "500 monthly credits",
      "80 uploads per month",
      "6 connected platforms",
      "Recovery Lab access",
    ],
  },
  {
    name: "Agency",
    subtitle: "For larger publishing operations",
    price: "$99.99",
    note: "per month",
    cta: "Choose Agency",
    bullets: [
      "2,000 monthly credits",
      "240 uploads per month",
      "6 connected platforms",
      "Export-ready analytics",
    ],
  },
];
